export const CSVPath = {
  Exceptions: "/csv/exceptions.csv",
  FleetList: "/csv/asset_details.csv",
  WorkOrderList: "/csv/work_order.csv",
  ConMonList: "/csv/conmon.csv",
  LatestConnection: "/csv/latest_connection.csv",
  MachineEventList: "/csv/machine_events.csv",
  RecommendationList: "/csv/recommendations.csv",
};
